
















import Vue from 'vue';
import { FitWxPhonex } from '@tencent/wphk-ui';

export default Vue.extend({
  name: 'FitHalfScreenOption',
  components: {
    FitWxPhonex,
  },
  props: {
    title: String,
    visible: Boolean,
    maskClose: {
      type: Boolean,
      default: true,
    },
    cancelText: String,
    options: Array,
  },
  methods: {
    onClose() {
      this.$emit('onClose');
    },
    handleClickMask(e: Event) {
      // @ts-ignore
      if (e?.target?.id === 'halfSelfOption') {
        if (this.maskClose) {
          this.onClose();
        }
      }
    },
    onOptionClick(optionName) {
      this.$emit('onOptionClick', optionName);
    },
    stop(e: Event) {
      e.preventDefault();
    },
  },
});
